import { Button, buttonVariants } from '@src/design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';
import { Text } from '@src/design-system/text';
import { Edit } from 'iconsax-react';
import { EllipsisVerticalIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import RegistrationInfo from './registration-info';
import AdditionalInfo from './additional-info';
import AddressInfo from './address-info';
import ContactInfo from './contact-info';
import EmergencyContactInformation from './emergency-contact-information';
import { createRoute } from '@src/core/router/paths';
import memberApi from '@shared/services/member-api';

const PersonalInfo = () => {
  const { partnerId } = useParams();
  const navigate = useNavigate();
  const { data: userData } = memberApi.useFetchOne({ id: partnerId });

  if (!userData) return null;

  const { user, address, contact_info, emergency_contact_info } = userData;

  return (
    <>
      <div className='flex justify-between items-center'>
        <Text className='text-gray-800 font-medium'>Personal Info</Text>
        <div className='flex items-center gap-2'>
          <Button
            size='sm'
            variant='primaryOutline'
            className='border-primary-200'
            onClick={() =>
              navigate(createRoute(`/users/partner/${partnerId}/edit`))
            }
          >
            <Edit />
            Edit
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger
              className={cn(
                buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
                'border-primary-200'
              )}
            >
              <EllipsisVerticalIcon />
            </DropdownMenuTrigger>

            <DropdownMenuContent align='center'>
              <DropdownMenuItem className='text-red-600'>
                Delete User
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <RegistrationInfo user={user} />
      <AdditionalInfo member={userData} />
      <AddressInfo address={address} />
      <ContactInfo contact_info={contact_info} />
      <EmergencyContactInformation
        emergency_contact_info={emergency_contact_info}
      />
    </>
  );
};

export default PersonalInfo;
